import {
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from '@material-ui/core'
import { useContext, useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { AuthContext } from '../../context/Auth/AuthContext'
import { useDate } from '../../hooks/useDate'


import { Frown, Pencil, Trash2 } from 'lucide-react'
import ConfirmationModal from '../../components/ConfirmationModal'
import api from '../../services/api'

import { useStyles } from './style'
export default function ChatList({
  chats,
  handleSelectChat,
  handleDeleteChat,
  handleEditChat,
  pageInfo,
  loading
}) {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useContext(AuthContext)
  const { datetimeToClient } = useDate()

  const [confirmationModal, setConfirmModalOpen] = useState(false)
  const [selectedChat, setSelectedChat] = useState({})

  const { id } = useParams()

  const goToMessages = async chat => {
    if (unreadMessages(chat) > 0) {
      try {
        await api.post(`/chats/${chat.id}/read`, { userId: user.id })
      } catch (err) {
        console.error(err)
      }
    }

    if (id !== chat.uuid) {
      history.push(`/chats/${chat.uuid}`)
      handleSelectChat(chat)
    }
  }
  const handleDelete = () => {
    handleDeleteChat(selectedChat)
  }

  const unreadMessages = chat => {
    const currentUser = chat.users.find(u => u.userId === user.id)
    return currentUser.unreads
  }

  const getPrimaryText = chat => {
    const mainText = chat.title
    const unreads = unreadMessages(chat)
    return (
      <div className={classes.boxTitleNewChat}>
        {<span className={classes.titleNewChat}>{mainText}</span>}

        {unreads > 0 && (
          <Chip
            size="small"
            // style={{ marginLeft: 5 }}
            label={unreads}
            // color="secondary"
            className={classes.badgeCountMessage}
          />
        )}
      </div>
    )
  }

  const getSecondaryText = chat => {
    // return chat.lastMessage !== ''
    //   ? `${datetimeToClient(chat.updatedAt)}: ${chat.lastMessage}`
    //   : ''

    if (chat.lastMessage !== '') {
      return (
        <>
          <span className={classes.lastMessage}>{chat.lastMessage}</span>
          <span className={classes.lastMessageTime}>
            {datetimeToClient(chat.updatedAt)}
          </span>
        </>
      )
    }
    return ''
  }

  //Removido borda lateral no chat
  // const getItemStyle = (chat) => {
  //   return {
  //     borderLeft: chat.uuid === id ? "6px solid #002d6e" : null,
  //    // backgroundColor: chat.uuid === id ? "#eee" : null,
  //   };
  // };


  return (
    <>
      <ConfirmationModal
        title={'Excluir Conversa'}
        open={confirmationModal}
        onClose={setConfirmModalOpen}
        onConfirm={handleDelete}
      >
        Esta ação não pode ser revertida, confirmar?
      </ConfirmationModal>
      <div className={classes.mainContainer}>
        <div className={classes.chatList}>
          {/* <List>
            {Array.isArray(chats) &&
              chats.length > 0 &&
              chats.map((chat, key) => (
                <ListItem
                  onClick={() => goToMessages(chat)}
                  key={key}
                  className={classes.listItem}
                  //   style={getItemStyle(chat)}
                  button
                >
                  <ListItemText
                    primary={getPrimaryText(chat)}
                    secondary={getSecondaryText(chat)}
                  />
                  {chat.ownerId === user.id && (
                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={() => {
                          goToMessages(chat).then(() => {
                            handleEditChat(chat)
                          })
                        }}
                        edge="end"
                        aria-label="delete"
                        size="small"
                        // style={{ marginRight: 5 }}
                      >
                        <Pencil size={20} />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setSelectedChat(chat)
                          setConfirmModalOpen(true)
                        }}
                        edge="end"
                        aria-label="delete"
                        size="small"
                      >
                        <Trash2 size={20} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              ))}
          </List> */}

          <List className={classes.listBox}>
            {Array.isArray(chats) && chats.length > 0 ? (
              chats.map((chat, key) => (
                <ListItem
                  onClick={() => goToMessages(chat)}
                  key={key}
                  className={classes.listItem}
                  button
                >
                  <ListItemText
                    primary={getPrimaryText(chat)}
                    secondary={getSecondaryText(chat)}
                    className={classes.listItemText}
                  />
                  {chat.ownerId === user.id && (
                    <ListItemSecondaryAction
                      className={classes.containerActionButtons}
                    >
                      <IconButton
                        className={classes.actionEditButton}
                        onClick={() => {
                          goToMessages(chat).then(() => {
                            handleEditChat(chat)
                          })
                        }}
                        edge="end"
                        aria-label="delete"
                        size="small"
                      >
                        <Pencil size={20} />
                      </IconButton>
                      <IconButton
                        className={classes.actionDeleteButton}
                        onClick={() => {
                          setSelectedChat(chat)
                          setConfirmModalOpen(true)
                        }}
                        edge="end"
                        aria-label="delete"
                        size="small"
                      >
                        <Trash2 size={20} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              ))
            ) : (
              <div className={classes.emptyList}>
                <span className={classes.emptyListTextTitle}>
                  <Frown />
                  Nada aqui!
                </span>
                <span>Crie uma conversa para comecar a conversar.</span>
              </div>
            )}
          </List>
        </div>
      </div>
    </>
  )
}
